import React from "react";
import { Switch, Route } from "react-router-dom";
import RMBuddyFilterBar from "../RMBuddyFilterBar";
import { Grid } from "semantic-ui-react";
import "./style.less";
import MultiCreateRmBuddies from "../MultiCreateRmBuddies";
import WarehouseTasksView from "../WarehouseTasksView";
import RMBuddyTasksView from "../RMBuddyTasksView";
import TaskDetailsPage from "../TaskDetailsPage";

function RMBuddyDashboard() {
  return (
    <div className="RMBuddyDashboard">
      <Grid id="ViewGrid">
        <Grid.Column width={3}>
          <RMBuddyFilterBar />
        </Grid.Column>
        <Grid.Column
          style={{
            padding: "45px"
          }}
          width={13}
        >
          <Switch>
            <Route exact path={`/rmBuddies/tasks/:taskId/`}>
              <TaskDetailsPage />
            </Route>

            <Route path={`/rmBuddies/excel/add`}>
              <MultiCreateRmBuddies />
            </Route>
            <Route exact path={`/rmBuddies/`}>
              <WarehouseTasksView />
            </Route>
            <Route exact path={`/rmBuddies/:warehouseId/`}>
              <WarehouseTasksView />
            </Route>
            <Route exact path={`/rmBuddies/:warehouseId/:rmBuddyId/`}>
              <RMBuddyTasksView />
            </Route>
          </Switch>
        </Grid.Column>
      </Grid>
    </div>
  );
}

RMBuddyDashboard.defaultProps = {};

RMBuddyDashboard.propTypes = {};

export default RMBuddyDashboard;
